/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

const defaultOptions = {} as const
export type GetLabOrderResultPdfQueryVariables = Types.Exact<{
  orderID: Types.Scalars['ID']['input']
}>

export type GetLabOrderResultPdfQuery = {
  __typename?: 'Query'
  labOrder: { __typename?: 'LabOrder'; orderID: string; resultPdf?: Types.Byte | null }
}

export const GetLabOrderResultPdfDocument = gql`
  query getLabOrderResultPdf($orderID: ID!) {
    labOrder(orderID: $orderID) {
      orderID
      resultPdf
    }
  }
`

/**
 * __useGetLabOrderResultPdfQuery__
 *
 * To run a query within a React component, call `useGetLabOrderResultPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabOrderResultPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabOrderResultPdfQuery({
 *   variables: {
 *      orderID: // value for 'orderID'
 *   },
 * });
 */
export function useGetLabOrderResultPdfQuery(
  baseOptions: Apollo.QueryHookOptions<GetLabOrderResultPdfQuery, GetLabOrderResultPdfQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLabOrderResultPdfQuery, GetLabOrderResultPdfQueryVariables>(
    GetLabOrderResultPdfDocument,
    options
  )
}
export function useGetLabOrderResultPdfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLabOrderResultPdfQuery, GetLabOrderResultPdfQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLabOrderResultPdfQuery, GetLabOrderResultPdfQueryVariables>(
    GetLabOrderResultPdfDocument,
    options
  )
}
export type GetLabOrderResultPdfQueryHookResult = ReturnType<typeof useGetLabOrderResultPdfQuery>
export type GetLabOrderResultPdfLazyQueryHookResult = ReturnType<typeof useGetLabOrderResultPdfLazyQuery>
export type GetLabOrderResultPdfQueryResult = Apollo.QueryResult<
  GetLabOrderResultPdfQuery,
  GetLabOrderResultPdfQueryVariables
>
